export default __webpack_public_path__ + "static/media/DCCCVIII_Screenshot.ae5b30bc.png";